import styled from 'styled-components';

export const StyledWhatsNewSection = styled.section``;
